import { AiInsightsConstants } from "../Constants/AiInsightsConstants.js";

const { ActionTypes } = AiInsightsConstants;

export const setMessage = (message) => ({
  type: ActionTypes.SET_MESSAGE,
  message,
});

export const fetchAiInsightsCategories = () => ({
  type: ActionTypes.GET_AI_INSIGHTS_CATEGORIES_REQUEST,
});

export const fetchAiInsightsSelectedReportData = (selectedCategory, selectedSubCategoryId) => ({
  type: ActionTypes.GET_AI_INSIGHTS_SELECTED_REPORT_DATA_REQUEST,
  selectedCategory,
  selectedSubCategoryId
});

export const setAiInsightsFeedback = (text, reaction, comments) => ({
  type: ActionTypes.SET_AI_INSIGHTS_FEEDBACK,
  text, reaction, comments
});
